import { createAsyncReducer } from '../../standard-actions/';
import {
    ILoadCaseDetailsAction,
    ILoadCaseDetailsSuccessAction,
    LoadCaseDetailsErrorAction
} from '../actions/load-case-details';
import { IChannelCareState } from '../state';
import { initialState } from '../state/initial-state';

export type LoadCaseDetailsAction
    = ILoadCaseDetailsAction
    | ILoadCaseDetailsSuccessAction
    | LoadCaseDetailsErrorAction;

const init = (state: IChannelCareState, action: LoadCaseDetailsAction) => ({
    ...state,
    caseDetails: {
        ...state.caseDetails,
        status: action.status
    }
});

const success = (state: IChannelCareState, action: LoadCaseDetailsAction) => ({
    ...state,
    caseDetails: {
        ...initialState.caseDetails,
        status: action.status,
        data: (action as ILoadCaseDetailsSuccessAction).data
    }
});

const failure = (state: IChannelCareState, action: LoadCaseDetailsAction) => ({
    ...state,
    caseDetails: {
        ...initialState.caseDetails,
        status: action.status,
        error: (action as LoadCaseDetailsErrorAction).error,
        code: (action as LoadCaseDetailsErrorAction).code
    }
});

export const loadCaseDetailsReducer = createAsyncReducer(initialState, init, success, failure);
